import api from "../api";

const getUnreadCount = () =>
  api.get("/social/notifications/unread_count");

const markRead = (eventId = null) => {
  const params = eventId != null ? { eid: eventId } : {};
  return api.post("/social/notifications/mark_read", null, { params });
};

export const socialNotificationApi = { getUnreadCount, markRead };
